<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="form-floating" :style="error.klient ? 'border: 1px solid red;' : ''">
                <input v-model="review.klient" type="text" class="form-control" id="floatingKlient" :placeholder="$t('reviews.text_8')">
                <label for="floatingKlient">{{ $t('reviews.text_8') }}</label>
            </div>
        </div>
        <div class="col-xl-12">
            <div class="form-floating">
                <input v-model="review.osoba" type="text" class="form-control" id="floatingOsoba" :placeholder="$t('reviews.text_9')">
                <label for="floatingOsoba">{{ $t('reviews.text_9') }}</label>
            </div>
        </div>
        <div class="col-xl-12">
            <div class="form-floating" :style="error.text ? 'border: 1px solid red;' : ''">
                <textarea v-model="review.text" class="form-control" :placeholder="$t('reviews.text_10')" id="floatingTextarea2" style="height: 150px"></textarea>
                <label for="floatingTextarea2">{{ $t('reviews.text_10') }}</label>
            </div>
        </div> 
        <div  class="col-xl-12">
            <div v-if="premium" class="btns">
                <div :class="create ? 'create_btn' : 'create_btn active'" @click="create_save">
                    {{ create ? $t('reviews.text_11') : $t('reviews.text_12') }}
                </div>
                <div v-if="create" @click="cancel" class="cancel_btn">
                    {{ $t('reviews.text_13') }}
                </div>
            </div>
            <save-button v-if="!premium" width="450"/>
        </div>
    </div>
</template>

<script>
import SaveButton from '../../../no_premium/SaveButton.vue'
    export default {
        components: { SaveButton },
        props: ['newReview','editReview', 'premium'],
        data() {
            return {
                create: false,
                review: {
                    id: null,
                    klient: null,
                    osoba: null,
                    text: null,
                    active: true,
                    edit: null,
                    delete: false
                },
                error: {
                    klient: null,
                    text: null
                }
            }
        },  
        methods: {
            create_save(){
                if(this.error.klient == false && this.error.text == false){
                    this.review.edit = false
                    var text = this.$t('reviews.text_14');
                    if(this.review.id){
                        this.review.edit = true;
                        text = this.$t('reviews.text_15');
                    }
                    axios
                    .post(`/api/reviews`, this.review)
                    .then(response => {
                        this.cancel()
                        this.$toast.success(text, { timeout: 3038, });
                    })
                    this.create = !this.create     
                    this.error.klient = false
                    this.error.text = false
                }else{
                    if(this.review.klient == null){
                        this.error.klient = true
                    }
                    if(this.review.text == null){
                        this.error.text = true
                    }
                }
    
            },
            cancel() {
                this.review = {
                    id: null,
                    klient: null,
                    osoba: null,
                    text: null,
                    active: true,
                    edit: null,
                    delete: false
                }
                this.$emit('changeReview', true)
                this.$emit('editReview')
                this.create = false
            }
        },
        watch: {
            editReview: function() {
                if(this.editReview){
                    this.create = true
                    this.review = this.editReview
                }
            },
            'review.klient': function(){
                this.error.klient = true
                if(this.review.klient != ""){
                    this.error.klient = false
                }
            },
            'review.text': function(){
                this.error.text = true
                if(this.review.text != ""){
                    this.error.text = false
                }
            }
        },
    }
</script>
<style lang="scss">
    .select_review{
        .v-input__slot{
            border: 1px solid #ced4da;
            box-shadow: none !important;
        }
        .v-text-field__details{
            margin-bottom: 0 !important;
        }
        .v-icon.v-icon{
            font-size:14px !important;
        }
    }
</style>
<style lang="scss" scoped>

    .row{
        width: 474px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 0 auto;
        padding: 0;
        .form-floating{
            input{
                display: flex !important;
                align-items: center !important;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
            label{
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
            }
            textarea{
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
        }
    }
    .btns{
        display: flex;
        align-items: center;
        justify-content: space-between;
        div{
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            width: 200px;
            height: 55px;
            box-sizing: border-box;
            border-radius: 4px;  
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #FFFFFF;
            &.cancel_btn{
                background: #F3385A;
            }
            &.create_btn{
                background: #2ED8B6;
            }
            &.create_btn.active{
                width: 100%;
            }
        }
    }
    

</style>